export { CenterLogo } from '@monorepo/shared-lib';
